import { useStaticQuery, graphql } from "gatsby"
import getOrganization from "../data/organization"

const useOrganizationId = () => {
    const { site } = useStaticQuery(graphql`
        query OrganizationSlugQuery {
            site {
                siteMetadata {
                    organizationSlug
                }
            }
        }
    `)

    const slug = site?.siteMetadata?.organizationSlug
    const organization = getOrganization(slug)
    return organization ? organization["@id"] : null
}

export { useOrganizationId }